import type { RouteLocationNormalized } from 'vue-router';

export function getLegacyMediaRedirect(route: RouteLocationNormalized) {
  const originalRoute = route.redirectedFrom;
  if (route.name !== 'library.index' || !originalRoute) return undefined;

  if (
    originalRoute.name === 'library.media' ||
    originalRoute.name === 'instagram.media' ||
    originalRoute.matched.some(({ path }) => path === '/library/media/:id')
  ) {
    return originalRoute;
  }

  const unbrandedRoute = originalRoute.matched.find(({ path }) =>
    ['/library/:_(.*)*', '/instagram/:_(.*)*'].includes(path),
  );
  const mediaPath = originalRoute.params?._;
  if (
    unbrandedRoute &&
    Array.isArray(mediaPath) &&
    mediaPath.length === 2 &&
    mediaPath[0] === 'media'
  ) {
    return {
      ...originalRoute,
      params: { ...originalRoute.params, id: mediaPath[1] },
      query: {
        ...originalRoute.query,
        ...(unbrandedRoute.path === '/instagram/:_(.*)*' ? { source: 'INSTAGRAM' } : {}),
      },
    };
  }

  return undefined;
}
